webpackJsonp([77046353047405],{

/***/ 1907:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"PatientDocumentEdge","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"cursor","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"node","type":{"kind":"OBJECT","name":"PatientDocument","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-patient-document-edge-ee5dfb1c7ad4becc3811.js